/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SequenceStepResponse } from './sequenceStepResponse';

/**
 * Full step set with nested ordered steps.
 */
export interface SequenceStepSetResponse {
  id: string;
  version_number: number;
  is_current: boolean;
  created_at: string;
  created_by_user_id: string;
  change_summary?: string | null;
  steps?: SequenceStepResponse[];
}
